import React from "react";
import { motion } from "framer-motion";
import Image from '../assets/profile.jpg'

const AboutSection = ({ isFullPage = false }) => {
  return (
    <section
      id="about"
      className={`relative py-24 ${isFullPage ? "min-h-screen flex items-center" : ""}`}
    >
      {/* Background glow */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-1/3 left-20 w-64 h-64 bg-blue-500/15 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-20 w-64 h-64 bg-orange-500/15 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              About <span className="gradient-text">Me</span>
            </h2>

            <p className="text-gray-300 leading-relaxed mb-6">
              Hello! I’m{" "}
              <span className="font-semibold text-white">
                Rameez Murtaza
              </span>
              , a passionate{" "}
              <span className="text-blue-400 font-medium">
                Full-Stack Developer
              </span>{" "}
              focused on building modern, scalable web and mobile applications.
              I enjoy crafting clean code and intuitive user experiences that
              feel effortless.
            </p>

            <p className="text-gray-300 leading-relaxed mb-6">
              My expertise includes{" "}
              <span className="text-orange-400 font-medium">
                React, Node.js, Express, MongoDB
              </span>{" "}
              and cross-platform development with{" "}
              <span className="text-red-400 font-medium">
                React Native & Expo
              </span>
              . I’m also actively working with AI-powered learning and data-driven
              solutions.
            </p>

            <p className="text-gray-400 leading-relaxed mb-10">
              When I’m not coding, I’m learning new technologies, contributing to
              side projects, and sharing knowledge to help others grow in tech.
            </p>

            {/* Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              viewport={{ once: true }}
              className="flex flex-wrap gap-4"
            >
              <motion.a
                href="/Rameez_Murtaza_CV.pdf"
                download
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-4 rounded-xl font-medium text-white 
                           bg-gradient-to-r from-blue-500 to-cyan-400 
                           shadow-glowBlue"
              >
                Download CV
              </motion.a>

              <motion.a
                href="mailto:rameezmurtaza@example.com"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-4 rounded-xl font-medium text-white 
                           border border-white/20 bg-white/5 backdrop-blur-md
                           hover:bg-white/10 transition-all"
              >
                Contact Me
              </motion.a>
            </motion.div>
          </motion.div>

          {/* Right Image */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            viewport={{ once: true }}
            className="relative flex justify-center"
          >
            <div className="relative rounded-2xl p-2 glass">
              <img
                src={Image}
                alt="Rameez Murtaza"
                className="w-72 md:w-80 rounded-2xl object-cover"
              />

              {/* Glow ring */}
              <div className="absolute -inset-1 rounded-2xl 
                              bg-gradient-to-r from-blue-500 via-red-500 to-orange-500 
                              opacity-20 blur-xl -z-10" />
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default AboutSection;
